import {createActions} from 'reduxsauce';

export const {Types: TimelineTypes, Creators: TimelineActionCreators} = createActions ({
    timelineStart: ["id"],
    timelineSuccess: ['data'],
    timelineFailure: ['error']
});